import React from "react";
const NotFound = () => {
    return (
        <div>
            <h1>404</h1>
            Usually we deliver, but this time NotFound & no cigar.<br />
            Use links to quide you back.
        </div>
    )
}

export default NotFound